"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Column = void 0;
const tslib_1 = require("tslib");
const components_1 = require("@bluebase/components");
const react_1 = tslib_1.__importStar(require("react"));
const useScreenSize_1 = require("../../useScreenSize");
const Row_1 = require("../Row");
const Column = (_a) => {
    var { style } = _a, rest = tslib_1.__rest(_a, ["style"]);
    const screenSize = useScreenSize_1.useScreenSize();
    const rowSize = react_1.useContext(Row_1.RowContext);
    const width = getColumnWidth(screenSize, rowSize, rest);
    const marginLeft = getColumnOffset(screenSize, rowSize, rest);
    // const styles = _styles as ColumnStyles;
    const stylesheet = [
        // styles.root,
        {
            flexDirection: 'column',
            marginLeft,
            width,
        },
        style,
    ];
    return (react_1.default.createElement(components_1.View, Object.assign({}, rest, { style: stylesheet })));
};
exports.Column = Column;
exports.Column.displayName = 'Column';
// Column.defaultStyles = (_theme: Theme): ColumnStyles => ({
// 	root: {
// 		flexDirection: 'column',
// 		// paddingHorizontal: theme.spacing.unit,
// 	}
// });
const toPercent = (num) => `${num * 100}%`;
const getColumnWidth = (screenSize, rowSize, props) => {
    switch (screenSize) {
        case 'sm':
            if (props.sm) {
                return toPercent(props.sm / rowSize);
            }
            break;
        case 'xs':
            if (props.xs) {
                return toPercent(props.xs / rowSize);
            }
            break;
        case 'xl':
            if (props.xl) {
                return toPercent(props.xl / rowSize);
            }
            break;
        case 'md':
            if (props.md) {
                return toPercent(props.md / rowSize);
            }
            break;
        case 'lg':
            if (props.lg) {
                return toPercent(props.lg / rowSize);
            }
    }
    return toPercent(getSize(rowSize, props) / rowSize);
};
const getColumnOffset = (screenSize, rowSize, props) => {
    switch (screenSize) {
        case 'sm':
            if (props.smOffset) {
                return toPercent(props.smOffset / rowSize);
            }
            break;
        case 'xs':
            if (props.xsOffset) {
                return toPercent(props.xsOffset / rowSize);
            }
            break;
        case 'xl':
            if (props.xlOffset) {
                return toPercent(props.xlOffset / rowSize);
            }
            break;
        case 'md':
            if (props.mdOffset) {
                return toPercent(props.mdOffset / rowSize);
            }
            break;
        case 'lg':
            if (props.lgOffset) {
                return toPercent(props.lgOffset / rowSize);
            }
    }
    return (props.offset) ? toPercent(props.offset / rowSize) : 0;
};
const getSize = (rowSize, props) => {
    if (props.size) {
        return props.size;
    }
    if (props.xs) {
        return props.xs;
    }
    if (props.sm) {
        return props.sm;
    }
    if (props.md) {
        return props.md;
    }
    if (props.lg) {
        return props.lg;
    }
    if (props.xl) {
        return props.xl;
    }
    return rowSize;
};
